(function ($) {
    function wrappBlock() {
        $(".filter-with-feeds .filter-data").each(function (index, sel) {
            // Wrap all div after h3
            $.each($('.filter-with-feeds .filter-data h3'), function (i, v) {
                $(v).nextUntil($('h3')).wrapAll('<div class="data-wrap block-wrapper"></div>');
            });

            var o;
            var itemLength1 = $(".filter-with-feeds .filter-data h3").length;
            for (var j = 0; j < itemLength1; j += 1) {
                if (j < itemLength1) {
                    o = j + 1;
                }
                var row1 = $(sel).find("h3").slice(j, o);
                row1.wrapAll("<span class='block-wrapper'></span>");
            }

            // Wrap 2 divs in 1 div
            var p;
            var itemLength2 = $(".filter-with-feeds .filter-data .block-wrapper").length;
            for (var l = 0; l < itemLength2; l += 2) {
                if (l < itemLength2) {
                    p = l + 2;
                }
                var row2 = $(sel).find(".block-wrapper").slice(l, p);
                row2.wrapAll("<div class='feed-column'></div>");
            }
        });
    }

    // Set h3
    function setData() {
        $('.filter-with-feeds .filter-wrap .alphabets-filter').empty();
        $(".filter-with-feeds .filter-data h3").each(function (index) {
            var value = $(this).text().trim();
            var text = $(this).text().trim().toLowerCase();
            $(this).parent().parent().attr('id', text);
            $('.filter-with-feeds .filter-wrap .alphabets-filter').append('<span>' + value + '</span>');
        });
    }

    $(document).ajaxSuccess(function () {
        wrappBlock();
        $('.filter-with-feeds .filter-data .feed-column').css({ 'display': 'block' }).addClass('show');
    });

    $(document).ready(function () {
        setTimeout (function() {
            $("body .filter-with-feeds .feed-wrapper .feed-column .views-element-container .js-view-dom-id-59d61a8a8747b3d9b23859e9ca26f2ec935d59b9ed9dfaff87b30d65ccefdb5e .col-two").each(function() {
                var para_length = jQuery(this).length;
                if (para_length === 1) {
                    $(this).parent().parent().parent().unwrap();
                }
            });        
          },400);
        

        if ($('.filter-with-feeds').length > 0) {
            wrappBlock();
            setData();

            $('.filter-with-feeds .filter-wrap .search form button').on('click', function (e) {
                e.preventDefault();
                var serTxt = $(this).siblings("input").val();
                $(".filter-with-feeds .filter-data .js-form-type-textfield input").val(serTxt);
                $(".filter-with-feeds #views-exposed-form-publication-block-5 .form-actions .form-submit").trigger("click");
            });

            $('.filter-with-feeds .filter-wrap .alphabets-filter span').on('click', function () {
                $(this).toggleClass('active');
                $(this).parents('.filter-wrap').toggleClass('remove-border');
                var filter_id = $(this).text().toLowerCase();
                $('.filter-with-feeds .filter-data .feed-column#' + filter_id).toggleClass('show').fadeToggle();
                if ($('.filter-with-feeds .filter-data .feed-column.show').length > 2) {
                    $('.filter-with-feeds .filter-data').addClass('show');
                }
                else {
                    $('.filter-with-feeds .filter-data').removeClass('show');
                }
            });
            $('.filter-with-feeds .filter-wrap .search form input').on('keyup', function () {
                if ($(this).val() == "") {
                    $(this).parent().find('.cross').hide();
                    $(this).css({ 'border': '1px solid #98002e' });
                } else {
                    $(this).parent().find('.cross').show();
                    $(this).css({ 'border': '2px solid #98002e' });
                }
            });

            $('.filter-with-feeds .filter-wrap .search form .cross').on('click', function () {
                $('.filter-with-feeds .filter-wrap .search form input').val('');
                $(this).hide();
                $('.filter-with-feeds .filter-wrap .search form input').css({ 'border': '1px solid #98002e' });
            });
        }
    });
})(jQuery);